import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

//备货清单查询
export const getStockingListAsync = params => {
    return axios.post(`${BaseApiUrl}/StockingList/GetStockingList`, params);
}

//备货清单明细
export const getStockingDetailAsync = params => {
    return axios.get(`${BaseApiUrl}/StockingList/GetStockingDetail`, { params: params });
}

//导出备货单
export const exportStockingListAsync = `${BaseApiUrl}/StockingList/StockingListAsyncOut`;

//打印备货清单查询
export const getStockingListPrint = params => {
    return axios.get(`${BaseApiUrl}/StockingList/GetStockingListPrint`, { params: params });
};

//打印备货清单
export const stockingListStatusPrint = params => {
    return axios.get(`${BaseApiUrl}/StockingList/StockingListStatusPrint`, { params: params });
};